export const ADD_CLASSES = 'ADD_CLASSES';
export const UPDATE_CLASSES = 'UPDATE_CLASSES';
export const ADD_CLASS_SUBJECT = 'ADD_CLASS_SUBJECT';
export const REPLACE_CLASSES = 'REPLACE_CLASSES';
export const CLASS_OPERATIONS = 'CLASS_OPERATIONS';
export const SET_SELECTED_CLASS = 'SET_SELECTED_CLASS';
